export default __webpack_public_path__ + "static/media/lysningen-property-17.4768fb86.jpg";